import React, { useState } from 'react';

const STATEMENT_PERIODS = [
  { id: '2025-03', label: 'March 2025' },
  { id: '2025-02', label: 'February 2025' },
  { id: '2025-01', label: 'January 2025' },
  { id: '2024-12', label: 'December 2024' },
  { id: '2024-11', label: 'November 2024' },
  { id: '2024-10', label: 'October 2024' },
  { id: '2024-09', label: 'September 2024' },
  { id: '2024-08', label: 'August 2024' },
  { id: '2024-07', label: 'July 2024' },
  { id: '2024-06', label: 'June 2024' },
  { id: '2024-05', label: 'May 2024' },
  { id: '2024-04', label: 'April 2024' },
  { id: '2024-03', label: 'March 2024' }
];

export default function Statements({ accounts }) {
  const [selectedAccount, setSelectedAccount] = useState('');
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleDownload = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));

    setSuccess(true);
    setLoading(false);
  };

  return (
    <div>
      {success && (
        <div className="mt-4 p-4 bg-primary-50 text-primary-700 rounded-xl border border-primary-200">
          Your statement will be sent to your registered email address.
        </div>
      )}

      <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
        <p className="text-sm text-yellow-800">
          Statements are available from March 2024 onwards. For older statements, please contact our support team at 1-800-Addition or email support@cuaddition.com
        </p>
      </div>

      <form onSubmit={handleDownload} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select Account
          </label>
          <select
            value={selectedAccount}
            onChange={(e) => setSelectedAccount(e.target.value)}
            className="w-full p-3 border border-gray-200 rounded-xl focus:ring-emerald-500 focus:border-emerald-500 bg-gray-50 hover:bg-white transition-colors duration-200"
            disabled={loading}
            required
          >
            <option value="">Choose an account</option>
            {accounts.map((account) => (
              <option key={account.type} value={account.type}>
                {account.type} (*{account.accountNumber.slice(-4)})
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Statement Period
          </label>
          <select
            value={selectedPeriod}
            onChange={(e) => setSelectedPeriod(e.target.value)}
            className="w-full p-3 border border-gray-200 rounded-xl focus:ring-emerald-500 focus:border-emerald-500 bg-gray-50 hover:bg-white transition-colors duration-200"
            disabled={loading}
            required
          >
            <option value="">Select period</option>
            {STATEMENT_PERIODS.map((period) => (
              <option key={period.id} value={period.id}>
                {period.label}
              </option>
            ))}
          </select>
        </div>

        <button
          type="submit"
          disabled={loading || !selectedAccount || !selectedPeriod}
          className={`w-full py-3 px-4 rounded-xl text-white font-medium
            ${loading || !selectedAccount || !selectedPeriod
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500'
            } transition-colors duration-200`}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <div className="w-5 h-5 border-t-2 border-b-2 border-white rounded-full animate-spin mr-2"></div>
              Processing...
            </div>
          ) : (
            'Download Statement'
          )}
        </button>

        <div className="mt-6 bg-gray-50 rounded-xl p-4">
          <h3 className="text-sm font-medium text-gray-900 mb-3">Recent Statements</h3>
          <div className="space-y-2">
            {STATEMENT_PERIODS.slice(0, 3).map((period) => (
              <div 
                key={period.id}
                className="flex items-center justify-between p-3 bg-white rounded-lg hover:bg-primary-50 transition-colors duration-200 cursor-pointer group"
              >
                <div className="flex items-center">
                  <span className="text-xl mr-3">📄</span>
                  <span className="text-sm text-gray-900">{period.label}</span>
                </div>
                <button className="text-primary-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  Download →
                </button>
              </div>
            ))}
          </div>
        </div>

        <p className="text-sm text-gray-500 mt-4">
          Note: Statements are generated as PDF files and will be sent to your registered email address.
        </p>
      </form>
    </div>
  );
} 